import { Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  copyrightContainer: { color: theme.palette.lottie.plainBackground, },
}));

const Copyright = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();



  //  ************
  //  ** Return **
  //  ************
  return (
    <Typography className={classes.copyrightContainer} variant="body2" color="textSecondary" align="center">
      {"Copyright "}
      <Link color="inherit" href="https://www.fxsistemas.com.br" target="_blank">FX Sistemas</Link>
      {" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default Copyright;
